import { render, staticRenderFns } from "./NoItems.vue?vue&type=template&id=765380a2&scoped=true"
import script from "./NoItems.vue?vue&type=script&lang=js"
export * from "./NoItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765380a2",
  null
  
)

export default component.exports